<template>
<!--  <el-tabs type="border-card">-->
<!--    <el-tab-pane label="研究对象">-->
  <el-row style="height: 100%">
    <el-col :span="isShowFunc&isshowWells?13:24" v-show="isShowFunc">
      <el-card body-style="padding:8px;height:calc(100vh - 50px - 36px - 8px - 8px)" style="height: calc(100vh - 50px)">
        <template #header style="height: 36px">
          <div class="card-header" style="justify-content: space-between;display: flex;align-items: center">
            <span>功能导航</span>
          </div>
        </template>
<!--      <el-tabs type="border-card" title="abc">-->
<!--      <el-collapse v-model="activeNames" @change="handleChange">-->
<!--        <el-collapse-item title="功能导航" name="2">-->
<!--          <template #title>-->
<!--            <span class="colspaseTitle">功能导航</span>-->
<!--          </template>-->
<!--          <el-scrollbar :height="activeNames.toString().indexOf('1')>=0?'calc(100vh - 180px)':'calc(100vh - 291px)'">-->
        <el-scrollbar>
            <el-tree
                :data="navigationData"
                :props="defaultProps"
                @node-click="handleNavigationNodeClick"
                node-key="id"
                default-expand-all
                :filter-node-method="filterNode"
                style="font-size: 14px"
                ref="tree">
              <template #default="{ node }">
                <span class="custom-tree-node">
                  <i :class="node.isLeaf?'el-icon-notebook-2':(node.expanded?'el-icon-folder-opened':'el-icon-folder')"></i><span>{{ node.label }}</span>
                </span>
<!--                <span v-if="blkTypeGroupId=='04'">-->
<!--                  <i class="small-operation-btn el-icon-plus" v-if=" node.data.pid=='0'" @click="onClickUserNodeAdd(node.data)"/>-->
<!--                  <i class="small-operation-btn el-icon-edit " v-if="node.data.pid!='0'" @click="onClickUserNodeRename(node.data)"/>-->
<!--                  <i class="small-operation-btn el-icon-delete" v-if="node.data.pid!='0'" @click=" onClickUserNodeDel(node.data)"/>-->
<!--              </span>-->
              </template>
            </el-tree>
<!--            <el-menu-->
<!--                router-->
<!--                :uniqueOpened="true"-->
<!--                default-active="1"-->
<!--                class="el-menu-vertical-demo"-->
<!--                style="min-width: 200px">-->
<!--              &lt;!&ndash;            :collapse = "true"&ndash;&gt;-->
<!--              <div v-for="naviData in navigationData" :key="naviData.idx">-->
<!--                <el-menu-item v-if="naviData.isLeaf" :index="naviData.idx" :disabled="naviData.templateSize<=0" :onclick="menuSelect">-->
<!--                  <i :class="naviData.iconName"></i>-->
<!--                  {{ naviData.name }}-->
<!--                </el-menu-item>-->
<!--                <el-submenu v-if="!naviData.isLeaf" :index=naviData.idx>-->
<!--                  <template #title>-->
<!--                    <i :class="naviData.iconName"></i>-->
<!--                    <span>{{ naviData.name }}</span>-->
<!--                  </template>-->
<!--                  &lt;!&ndash;            <el-scrollbar :height="naviData.children.length>6?300:(naviData.children[0].isLeaf?naviData.children.length*50:'100%')">&ndash;&gt;-->
<!--                  <div v-for="childData in naviData.children" :key="childData.idx">-->
<!--                    <el-menu-item v-if="childData.isLeaf" :index="childData.idx" :class="childData.iconName" :disabled="childData.templateSize<=0" :onclick="menuSelect">-->
<!--                      {{ childData.name }}-->
<!--                    </el-menu-item>-->
<!--                    <el-submenu v-if="!childData.isLeaf" :index="childData.idx">-->
<!--                      <template #title>-->
<!--                        <i :class="childData.iconName"></i>-->
<!--                        <span>{{ childData.name }}</span>-->
<!--                      </template>-->
<!--                      <div v-for="grandChild in childData.children" :key="grandChild.idx">-->
<!--                        <el-menu-item v-if="grandChild.isLeaf"-->
<!--                                      :index="grandChild.idx"-->
<!--                                      :class="grandChild.iconName" :disabled="grandChild.templateSize<=0" :onclick="menuSelect">-->
<!--                          {{ grandChild.name }}-->
<!--                        </el-menu-item>-->
<!--                        <el-menu-item-group v-if="!grandChild.isLeaf">-->
<!--                          <template #title>-&#45;&#45;{{ grandChild.name }}-&#45;&#45;</template>-->
<!--                          <el-menu-item v-for="levData in grandChild.children" :key="levData.idx" :index="levData.idx"-->
<!--                                        :class="levData.iconName" :disabled="levData.templateSize<=0" :onclick="menuSelect">-->
<!--                            {{ levData.name }}-->
<!--                          </el-menu-item>-->
<!--                        </el-menu-item-group>-->
<!--                      </div>-->
<!--                    </el-submenu>-->
<!--                  </div>-->
<!--                  &lt;!&ndash;            </el-scrollbar>&ndash;&gt;-->
<!--                </el-submenu>-->
<!--              </div>-->
<!--            </el-menu>-->
          </el-scrollbar>
<!--        </el-collapse-item>-->

<!--        <el-collapse-item name="1" v-if="false">-->
<!--          <template #title>-->
<!--            &lt;!&ndash;            研究对象<i class="el-icon-s-home" onclick="alert(3)"></i>&ndash;&gt;-->
<!--            <div @click="stopProp">-->
<!--              <el-dropdown trigger="click" @command="onBlkTypeCommand" :hide-on-click="true">-->
<!--              <span class="el-dropdown-link">-->
<!--                {{blkTypeGroupName}}-->
<!--              </span>-->
<!--                <template #dropdown>-->
<!--                  <el-dropdown-menu>-->
<!--&lt;!&ndash;                    <el-dropdown-item  command="project1" :icon="{'custom-icon el-icon-check':blkTypeGroupId=='01'}">油田区块(一期)</el-dropdown-item>&ndash;&gt;-->
<!--                    <el-dropdown-item  command="bankGeoUnit" :icon="{'custom-icon el-icon-check':blkTypeGroupId=='02'}">地质单元(银行)</el-dropdown-item>-->
<!--                    &lt;!&ndash;                  <el-dropdown-item  command="planBlock" :icon="{'custom-icon el-icon-check':blkTypeGroupId=='03'}">计划区块</el-dropdown-item>&ndash;&gt;-->
<!--                    <el-dropdown-item  command="userBlock" :icon="{'custom-icon el-icon-check':blkTypeGroupId=='04'}">个人井组</el-dropdown-item>-->
<!--                  </el-dropdown-menu>-->
<!--                </template>-->
<!--              </el-dropdown>-->
<!--            </div>-->
<!--          </template>-->
<!--          <el-input-->
<!--              placeholder="输入关键字进行过滤"-->
<!--              v-model="filterText">-->
<!--          </el-input>-->
<!--          <el-progress-->
<!--              :percentage="100"-->
<!--              status="success"-->
<!--              :indeterminate="true"-->
<!--              :duration="5"-->
<!--              v-if="blkprogressvisible">加载中-->
<!--          </el-progress>-->
<!--          <el-scrollbar :height="activeNames.toString().indexOf('2')>=0?'calc(50vh - 180px)':'calc(100vh - 333px)'">-->
<!--            <el-tree-->
<!--                class="filter-tree"-->
<!--                :data="data"-->
<!--                :props="defaultProps"-->
<!--                node-key="id"-->
<!--                show-checkbox-->
<!--                @check="handleCheckChange"-->
<!--                :expand-on-click-node="false"-->
<!--                :default-expanded-keys="defexpandBlk"-->
<!--                :default-checked-keys="defcheckedBlk"-->
<!--                :filter-node-method="filterNode"-->
<!--                ref="tree">-->
<!--              <template #default="{ node }">-->
<!--                <span class="custom-tree-node">-->
<!--                  <i class="el-icon-s-home"></i><span>{{ node.label }}</span>-->
<!--                </span>-->
<!--                <span v-if="blkTypeGroupId=='04'">-->
<!--                  <i class="small-operation-btn el-icon-plus" v-if=" node.data.pid=='0'" @click="onClickUserNodeAdd(node.data)"/>-->
<!--                  <i class="small-operation-btn el-icon-edit " v-if="node.data.pid!='0'" @click="onClickUserNodeRename(node.data)"/>-->
<!--                  <i class="small-operation-btn el-icon-delete" v-if="node.data.pid!='0'" @click=" onClickUserNodeDel(node.data)"/>-->
<!--              </span>-->
<!--              </template>-->
<!--            </el-tree>-->
<!--            &lt;!&ndash;              <template #default="{ node }">&ndash;&gt;-->
<!--            &lt;!&ndash;                <el-image src="/采气井.png" lazy style="margin:0px 0px 0 0px; width:16px;height:16px"></el-image>&ndash;&gt;-->
<!--            &lt;!&ndash;                <span class="custom-tree-node">&ndash;&gt;-->
<!--            &lt;!&ndash;                  <span>{{ node.label }}</span>&ndash;&gt;-->
<!--            &lt;!&ndash;                </span>&ndash;&gt;-->
<!--            &lt;!&ndash;              </template>&ndash;&gt;-->
<!--          </el-scrollbar>-->
<!--        </el-collapse-item>-->
<!--      </el-collapse>-->
<!--      </el-tabs>-->
      </el-card>
    </el-col>
<!--    </el-tab-pane>-->
<!--    <el-tab-pane label="研究井位">-->
    <el-col :span="isShowFunc&isshowWells?11:24" v-show="isshowWells">
      <el-tabs type="border-card">
      <el-input
          placeholder="输入关键字进行过滤"
          v-model="wellfilterText">
      </el-input>
      <el-progress
          :percentage="100"
          status="success"
          :indeterminate="true"
          :duration="5"
          v-if="wellprogressvisible">加载中
      </el-progress>
      <el-scrollbar height="calc(100vh - 207px)">
        <el-tree icon-class=""
                 class="filter-tree"
                 :data="welldata"
                 :props="defaultProps"
                 node-key="id"
                 default-expand-all
                 :expand-on-click-node="false"
                 :filter-node-method="filterWellNode"
                 @node-click="handleWellCheckChange"
                 ref="welltree">
          <template #default="{ node }">
            <el-image :src="getWellNodeIcon(data,node)"
                      style="margin:0px 0px 0 0px; width:16px;height:16px"></el-image>
            <span class="custom-tree-node">
                  <span>{{ node.label }}</span>
                </span>
          </template>
        </el-tree>
      </el-scrollbar>
      </el-tabs>
    </el-col>
  </el-row>
<!--    </el-tab-pane>-->
<!--  </el-tabs>-->
  <!--    个人井组选井弹出框-->
  <div v-dialogDrag>
    <el-dialog
        v-model="selectionUserBlock"
        title="选井"
        width="650px"
        :destroy-on-close="true">
      <el-form :inline="true" label-width="90px">
        <el-form-item label="名称：">
          <el-input size="small" v-model="userBlocks.name"></el-input>
        </el-form-item>
        <el-form-item label="主井：">
          <el-select v-model="userBlocks.wellPkey" filterable size="small" style="width: 92%">
            <el-option v-for="item in userBlocks.wells"
                       :key="item"
                       :label="item"
                       :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区块：">
          <el-input size="small" v-model="userBlocks.blockFilterText" placeholder="筛选区块"></el-input>
          <el-scrollbar height="260px">
            <el-tree
                class="filter-tree"
                :data="userBlockData"
                :props="defaultProps"
                node-key="BLOCK_ID"
                show-checkbox
                @check="handleBlockCheckUser"
                ref="userBlockTree"
                :filter-node-method="userBlocksFilterNode"
                :default-expanded-keys="blockExpandedKeys"
                :default-checked-keys="blockCheckedKeyList">
            </el-tree>
          </el-scrollbar>
        </el-form-item>
        <el-form-item label="单井：">
          <el-input size="small" v-model="userBlocks.wellFilterText" placeholder="筛选井"></el-input>
          <el-scrollbar height="260px">
            <el-tree
                class="filter-tree"
                :data="userWellData"
                :props="defaultProps"
                node-key="id"
                show-checkbox
                default-expand-all
                :expand-on-click-node="false"
                @check="handleWellCheckUser"
                ref="userWellTree"
                :filter-node-method="userBlocksFilterNode"
                :default-expanded-keys="userBlocks.wellCheckedKeys"
                :default-checked-keys="userBlocks.wellCheckedKeys">
            </el-tree>
          </el-scrollbar>
        </el-form-item>
      </el-form>
      <template #footer>
      <span class="dialog-footer">
        <el-button @click="selectionUserBlock = false">取消</el-button>
        <el-button type="primary" @click="addUserBlock">确认</el-button>
      </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import eventbus from '@/event'
import {ElMessage, ElMessageBox} from 'element-plus'

export default {
  name: 'NavigationWindow',
  watch: {
    isShowWell:{
      handler(newVal,oldVal) {
        this.isshowWells = newVal;
        if(oldVal!=newVal){
          if(newVal){
            if(this.blkTypeGroupId == '04')
            {
              this.fetchUserGrpWellData();
            }
            else{
              // 井位与区块关联脱开，默认为所有井
              if(!this.wellIsFetched){
                this.fetchWellData();
              }
            }
          }
        }
      }
    },
    '$store.state.singleWellNum': function(){
      let wellId = this.$store.state.singleWell[0].id;
      this.$refs.welltree.setCurrentKey(wellId);
      // 展开所有节点
      let nodes = this.$refs.welltree.store.nodesMap
      for (let i in nodes) {
        nodes[i].expanded = true;
      }
      // let curNode = this.$refs.welltree.getCurrentNode();
      // console.log("curNode",curNode)
      // console.log("curNode",curNode.$treeNodeId)
      // console.log("this.$store.state.singleWell",this.$store.state.singleWell[0].id)
      this.$refs.welltree.$el.scrollTop = 500
    },
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    wellfilterText(val) {
      this.$refs.welltree.filter(val);
    },
    rootNavigateId() {
      console.log("rootID:", this.rootNavigateId);
      this.fetchNavigateData();
    },
    //监听个人井组 选区块筛选内容变化
    "userBlocks.blockFilterText"(val){
      this.$refs.userBlockTree.filter(val);
    },
    //监听个人井组 选井筛选内容变化
    "userBlocks.wellFilterText"(val){
      this.$refs.userWellTree.filter(val);
    },
  },
  created: function () {
    eventbus.on('moduleChange', (module) => {
      this.onModuleChange(module);
    });
    eventbus.on('moduleRefresh', () => {
      this.onModuleRefresh();
    });
  },
  mounted: function () {
    let lyqtUserInfo = JSON.parse(localStorage.getItem("lyqtUserInfo"));
    this.lyqtUserInfoUserId=lyqtUserInfo.userId;
    this.init();
    // this.elNavigateScrollBarHeight = ''
    // console.log(_this.defexpandBlk);
  },
  components: {},
  methods: {
    menuSelect(obj){
      console.log(obj)
      // if(obj !=undefined && obj!= null && obj.target !=undefined && obj.target != null && obj.target.innerText!=undefined && obj.target.innerText != null){
      //   let curSelMenuText = obj.target.innerText;
      //   this.isShowWellOld = JSON.parse(JSON.stringify(this.isshowWells));
      //   if(curSelMenuText.indexOf("日")>=0 && curSelMenuText.indexOf("日志")<0){
      //     if(!this.isshowWells){
      //       this.isshowWells = true;
      //     }
      //   }
      //   else{
      //     this.isshowWells = JSON.parse(JSON.stringify(this.isShowWellOld));
      //   }
      // }
    },
    stopProp: function (e) {e.stopPropagation()},
    init(){this.initWithParm(false)},
    initWithParm(needFetchWell){
      console.log(needFetchWell)
      // let _this = this;
      this.wellprogressvisible = false;
      this.blkprogressvisible = false;
      // this.fetchNavigateData();
      this.blkTypeGroupId = localStorage.getItem("blockType");
      if (this.blkTypeGroupId == null || this.blkTypeGroupId==undefined) this.blkTypeGroupId = "02";
      if(this.blkTypeGroupId==="01"){
        this.onBlkTypeCommand('bankGeoUnit');
      }

      if(this.blkTypeGroupId==="01")
      {
        this.blkTypeGroupName = "油田区块(一期)";
        this.wellDataUrl=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/wellData";
        this.blkDataUrl=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/blockData";
        this.defexpandBlk = [0];
      }
      else if(this.blkTypeGroupId==="02"){
        this.blkTypeGroupName = "地质单元(银行)";
        this.wellDataUrl=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/bankWellData";
        this.blkDataUrl=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/bankGeoUnit";
        this.defexpandBlk = [0];
      }
      else if(this.blkTypeGroupId==="03"){
        this.blkTypeGroupName = "计划区块";
        this.wellDataUrl=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/bankWellData";
        this.blkDataUrl=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/planBlock";
        this.defexpandBlk = [0];
      }else {
        this.blkTypeGroupName = "个人井组";
        this.wellDataUrl=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/userWellData";
        this.blkDataUrl=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/userBlockData"+`?userId=${this.lyqtUserInfoUserId}`;
        this.defexpandBlk = ["0"];
      }


      // this.fetchData();
      //
      // let checkedBlk = localStorage.getItem("checkedBlock");
      // console.log("bbbbb-----checkedBlk:",checkedBlk);
      // if (checkedBlk == null|| checkedBlk==undefined) checkedBlk = {};
      // if(needFetchWell)
      // {
      //   if(_this.blkTypeGroupId == '04')
      //   {
      //     _this.fetchUserGrpWellData();
      //   }
      //   else{
      //     // 井位与区块关联脱开，默认为所有井
      //     _this.fetchWellData();
      //   }
      // }
      // if (checkedBlk.length > 0) {
      //   _this.checkedBlock = JSON.parse(checkedBlk);
      //   for (let key in _this.checkedBlock)
      //     _this.defcheckedBlk.push(_this.checkedBlock[key].id);
      //   if (_this.defcheckedBlk.length > 0)
      //     _this.defexpandBlk = _this.defcheckedBlk;
      //   _this.$parent.$parent.$parent.statistics(JSON.stringify(_this.checkedBlock));
      // }
    },
    onBlkTypeCommand(command){
      if(command === 'project1'){
        this.blkTypeGroupName = "油田区块(一期)";
        if(this.blkTypeGroupId === '01')
          return;
        this.blkTypeGroupId = '01';
        this.wellDataUrl=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/wellData";
        this.blkDataUrl=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/blockData";
      }
      else if ((command === 'bankGeoUnit')){
        this.blkTypeGroupName = "地质单元(银行)";
        if(this.blkTypeGroupId === '02')
          return;
        this.blkTypeGroupId = '02';
        this.wellDataUrl=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/bankWellData";
        this.blkDataUrl=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/bankGeoUnit";
      }
      else if ((command === 'planBlock')){
        this.blkTypeGroupName = "计划区块";
        if(this.blkTypeGroupId === '03')
          return;
        this.blkTypeGroupId = '03';
        this.wellDataUrl=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/bankWellData";
        this.blkDataUrl=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/planBlock";
      }
      else {
        this.blkTypeGroupName = "个人井组";
        if(this.blkTypeGroupId === '04')
          return;
        this.blkTypeGroupId = '04';
        this.wellDataUrl=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/userWellData";
        this.blkDataUrl=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/userBlockData"+`?userId=${this.lyqtUserInfoUserId}`;
      }
      // console.log(111,localStorage.getItem("checkedBlock"))
      localStorage.removeItem("checkedBlock");
      // console.log(222,localStorage.getItem("checkedBlock"))
      localStorage.setItem("blockType", this.blkTypeGroupId);
      this.defcheckedBlk = [];
      this.welldata = [];
      this.initWithParm(this.wellIsFetched?false:true);
    },
    //获取勾选油田数据
    handleCheckChange(currentNode, checkedObjs) {
      let _this = this;
      // console.log(currentNode, checkedObjs);
      // eslint-disable-next-line no-unused-vars
      let wells = [];
      let wellData = [];
      let label=null;
      _this.checkedBlock = {};
      let checkednodes = checkedObjs.checkedNodes;
      if (checkednodes.length > 0) {
        label=checkednodes[0].label;
        for (let nodeIdx in checkedObjs.checkedNodes) {
          let data = checkednodes[nodeIdx];
          //判断是否是最小的节点
          if (data.ISLEAF === 1) {
            _this.checkedBlock[data.BLOCK_ID] = data;
            //获取最小区块名称
            wellData.push(data.label);
          }
        }
      }
      wells.push(label);
      wells.push(wellData);
      wells.push("qk");
      wells.push(this.blkTypeGroupId);
      this.$store.state.wellData = [];//清空vuex中的保存信息
      this.$store.state.wellData = wells;//将信息存入vuex中
      localStorage.setItem("wells",JSON.stringify(wells));
      console.log("wells:", wells);
      //将当前选中区块设置为全局
      console.log("checkedBlkList:",_this.checkedBlock);
      localStorage.setItem("checkedBlock", JSON.stringify(_this.checkedBlock));
      //设置井组井
      if(_this.blkTypeGroupId == '04')
      {
        _this.fetchWellGrpData();
        _this.fetchUserGrpWellData();
      }
      else{
        // 井位与区块关联脱开，默认为所有井
        // _this.fetchWellData();
        _this.setWellDataByCheckedBlk();
      }

      //调用父组件的方法，刷新数据
      _this.$parent.$parent.$parent.statistics(JSON.stringify(_this.checkedBlock));
    },
    handleChange(val) {
      console.log(val);
    },
    //过滤节点
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //过滤井节点，根据输入的井号对比过滤
    filterWellNode(value, data) {
      if (!value) return true;
      if(data.label == null || data.label == undefined) return true;
      return data.label.indexOf(value.toUpperCase()) !== -1;
    },
    //获取导航数据
    fetchNavigateData() {
      let that = this;
      console.log(that.rootNavigateId);
      if (that.rootNavigateId.length > 0) return;
      let strpid = that.rootNavigateId.moduleid;
      let strmode = 'rootidmode';
      let strnavigateUrl = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/navigateData";
      if (strpid.length > 0 && strmode.length > 0)
        strnavigateUrl += "?pid=" + strpid + "&mode=" + strmode;

      that.navigationData = [
          {"idx":"6","iconName":"el-icon-s-help","name":"许可申请","label":"许可申请","isLeaf":false,"lev":2,"moduleid":"4A59525532DD463F9A9CC3C80AB5DF8F","pid":"511029F7F507403FAB16414EEE68653D","seq":1010000,"countpageid":null,"templateSize":89,
            "children":[
              {"idx":"6-1","iconName":"el-icon-notebook-2","name":"许可申请","label":"许可申请","isLeaf":true,"lev":3,"moduleid":"5955c85eb4064ba981a6594872a816d0","pid":"4A59525532DD463F9A9CC3C80AB5DF8F","seq":1010100,"countpageid":"6DE89A7D20DB4ADCA01F4DD759160517","templateSize":100},
              {"idx":"6-2","iconName":"el-icon-notebook-2","name":"许可日志","label":"许可日志","isLeaf":true,"lev":3,"moduleid":"ae75237f3f6c498fbb621a9e65095d6f","pid":"4A59525532DD463F9A9CC3C80AB5DF8F","seq":1010200,"countpageid":"BF839CB76B40431CAE8F4E9E7B252116","templateSize":100},
            ]
          }
      ];
      let userInfoSession = localStorage.getItem("licUserINFO");
      if (!(userInfoSession === null || userInfoSession === undefined)) {
        userInfoSession = JSON.parse(userInfoSession);
        if(userInfoSession.ISADMIN === "1"){
          that.navigationData = [
            {"idx":"6","iconName":"el-icon-s-help","name":"许可申请","label":"许可申请","isLeaf":false,"lev":2,"moduleid":"4A59525532DD463F9A9CC3C80AB5DF8F","pid":"511029F7F507403FAB16414EEE68653D","seq":1010000,"countpageid":null,"templateSize":89,
              "children":[
                {"idx":"6-1","iconName":"el-icon-notebook-2","name":"许可申请","label":"许可申请","isLeaf":true,"lev":3,"moduleid":"5955c85eb4064ba981a6594872a816d0","pid":"4A59525532DD463F9A9CC3C80AB5DF8F","seq":1010100,"countpageid":"6DE89A7D20DB4ADCA01F4DD759160517","templateSize":100},
                {"idx":"6-2","iconName":"el-icon-notebook-2","name":"许可日志","label":"许可日志","isLeaf":true,"lev":3,"moduleid":"ae75237f3f6c498fbb621a9e65095d6f","pid":"4A59525532DD463F9A9CC3C80AB5DF8F","seq":1010200,"countpageid":"BF839CB76B40431CAE8F4E9E7B252116","templateSize":100},
              ]
            },
            {"idx":"7","iconName":"el-icon-s-help","name":"系统设置","label":"系统设置","isLeaf":false,"lev":2,"moduleid":"4A59525532DD463F9A9CC3C80AB5DF8F","pid":"511029F7F507403FAB16414EEE68653D","seq":1020000,"countpageid":null,"templateSize":89,
              "children":[
                {"idx":"6-3","iconName":"el-icon-notebook-2","name":"用户管理","label":"用户管理","isLeaf":true,"lev":3,"moduleid":"5955c85eb4064ba981a6594872a816d0","pid":"4A59525532DD463F9A9CC3C80AB5DF8F","seq":1020100,"countpageid":"6DE89A7D20DB4ADCA01F4DD759160517","templateSize":100},
                {"idx":"6-4","iconName":"el-icon-notebook-2","name":"产品管理","label":"产品管理","isLeaf":true,"lev":3,"moduleid":"ae75237f3f6c498fbb621a9e65095d6f","pid":"4A59525532DD463F9A9CC3C80AB5DF8F","seq":1020200,"countpageid":"BF839CB76B40431CAE8F4E9E7B252116","templateSize":100},
                {"idx":"6-5","iconName":"el-icon-notebook-2","name":"单位管理","label":"单位管理","isLeaf":true,"lev":3,"moduleid":"ae75237f3f6c498fbb621a9e65095d6f","pid":"4A59525532DD463F9A9CC3C80AB5DF8F","seq":1020300,"countpageid":"BF839CB76B40431CAE8F4E9E7B252116","templateSize":100},
                {"idx":"6-6","iconName":"el-icon-notebook-2","name":"许可配置","label":"许可配置","isLeaf":true,"lev":3,"moduleid":"ae75237f3f6c498fbb621a9e65095d6f","pid":"4A59525532DD463F9A9CC3C80AB5DF8F","seq":1020400,"countpageid":"BF839CB76B40431CAE8F4E9E7B252116","templateSize":100}//,
                // {"idx":"7-5","iconName":"el-icon-notebook-2","name":"参数配置","label":"参数配置","isLeaf":true,"lev":3,"moduleid":"a4ff94a76dc949ee919da2bc0c870d50","pid":"4A59525532DD463F9A9CC3C80AB5DF8F","seq":1020500,"countpageid":"632254755ad542e59c569e7f8d7812a1","templateSize":100}
              ]
            }
          ];
        }
      }
      // axios({
      //   url: strnavigateUrl,
      //   method: 'GET'
      // }).then((res) => {
      //   if (res.status === 200) {
      //     that.navigationData = res.data;
      //     console.log("Navigate:",strmode,res,JSON.stringify(that.navigationData));
      //   }
      //   that.loading = false;
      // }).catch((err) => {
      //   alert('Error');
      //   console.log(err)
      //   that.loading = false;
      // })
    },
    //获取数据
    fetchData() {
      // console.log("blkDataUrl:",this.blkDataUrl);
      let that = this;
      that.blkprogressvisible = true;
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (jwtSession == null) jwtSession = "";
      axios({
        url: that.blkDataUrl,
        headers: {
          "Authorization": "Bearer " + jwtSession
        },
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          that.data = res.data;
          console.log("区块：",res);
        }
        that.blkprogressvisible = false;
      }).catch((err) => {
        // alert('Error');
        console.log(err)
        that.blkprogressvisible = false;
      })
    },
    fetchWellGrpData() {
      let that = this;
      // console.log("currentSelBlk",that.checkedBlock)
      axios({
        url: that.wellDataUrl,
        method: 'POST',
        headers: {"Content-Type": "application/json"},
        data: that.checkedBlock
      }).then((res) => {
        if (res.status === 200) {
          this.$store.state.wellgroupData = [];
          this.$store.state.wellgroupData = res.data;//将井数据存储vuex中
        }
        that.loading = false;
      }).catch((err) => {
        // alert('Error');
        console.log(err)
      })
    },
    setWellDataByCheckedBlk(){
      this.wellprogressvisible = true;
      let checkedWellData = JSON.parse(JSON.stringify(this.fullBankWellData));
      if(this.checkedBlock == null || this.checkedBlock == undefined || Object.keys(this.checkedBlock).length == 0) {
        this.welldata = [];
        // this.welldata = checkedWellData;
        this.$store.state.wellgroupData = [];
        // this.$store.state.wellgroupData = checkedWellData;//将井数据存储vuex中
        this.$nextTick(()=> {
          this.wellprogressvisible = false;
        },100);
        return ;
      }
      for(let idxa=0;idxa<checkedWellData.length;idxa++){
        let rootWellNode = checkedWellData[idxa];
        if(rootWellNode.children!=null && rootWellNode.children.length>0){
          for(let idxb=rootWellNode.children.length-1;idxb>=0;idxb--){
            let jbNode = rootWellNode.children[idxb];
            if(jbNode.children!=null && jbNode.children.length>0){
              for(let idxc=jbNode.children.length-1;idxc>=0;idxc--){
                let wellNode = jbNode.children[idxc];
                let qkidVal = wellNode.QK_ID;
                let isNeedRemove = true;
                for (let key in this.checkedBlock) {
                  if (qkidVal == this.checkedBlock[key].value) {
                    isNeedRemove = false;
                    break;
                  }
                }
                if(isNeedRemove){
                  jbNode.children.splice(idxc,1)
                }
              }
              if(jbNode.children.length==0){
                rootWellNode.children.splice(idxb,1)
              }
            }
          }
        }
      }
      this.welldata = checkedWellData;
      this.$store.state.wellgroupData = [];
      this.$store.state.wellgroupData = checkedWellData;//将井数据存储vuex中
      this.$nextTick(()=> {
        this.wellprogressvisible = false;
      },100);
    },
    //获取井数据
    fetchWellData() {
      let that = this;
      that.wellprogressvisible = true;
      // console.log("currentSelBlk",that.checkedBlock)
      // axios({
      //   url: that.wellDataUrl,
      //   method: 'POST',
      //   headers: {"Content-Type": "application/json"},
      //   data: that.checkedBlock
      // }).then((res) => {
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (jwtSession == null) jwtSession = "";
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/bankWellDataWithJwt",
        method: 'POST',
        headers: {
          "Authorization": "Bearer " + jwtSession
        },
      }).then((res) => {
        if (res.status === 200) {
          that.fullBankWellData = res.data;
          that.setWellDataByCheckedBlk();
          that.wellprogressvisible = false;
          // console.log(res);
        }
        that.loading = false;
        this.wellIsFetched = true;
      }).catch((err) => {
        // alert('Error');
        console.log(err)
        that.wellprogressvisible = false;
      })
    },
    fetchUserGrpWellData() {
      let that = this;
      that.wellprogressvisible = true;
      // console.log("currentSelBlk",that.checkedBlock)
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/userWellData",
        method: 'POST',
        headers: {"Content-Type": "application/json"},
        data: that.checkedBlock
      }).then((res) => {
        if (res.status === 200) {
          that.welldata = res.data;
          that.$store.state.wellgroupData = [];
          that.$store.state.wellgroupData = res.data;//将井数据存储vuex中
          that.wellprogressvisible = false;
          // console.log(res);
        }
        that.loading = false;
      }).catch((err) => {
        // alert('Error');
        console.log(err)
        that.wellprogressvisible = false;
      })
    },
    //模块更改
    onModuleChange(module) {
      let that = this;
      that.enumerateNavigationData(that.navigationData, module);
    },
    //模块刷新
    onModuleRefresh() {
      let that = this;
      that.fetchNavigateData();
    },
    //枚举导航数据
    enumerateNavigationData(node, module) {
      let that = this;
      node.map((item) => {
        if (item.isLeaf) {
          if (item.moduleid == module.moduleid) {
            item.name = module.name;
          }
        } else {
          that.enumerateNavigationData(item.children, module);
        }
      })
    },
    //获取井节点图标
    getWellNodeIcon(data, node) {
      let jbStr = node.data.MQJB;
      if (jbStr != "采油井" && jbStr != "采气井" && jbStr != "注水井" && jbStr != "注气井")
        jbStr = "井";
      console.log("wellIcon",jbStr)
      return "/" + jbStr + ".png"
    },
    handleNavigationNodeClick(curnode){//导航点击事件
      console.log("curClickNode",curnode)
      if(curnode!= undefined && curnode != null && curnode.idx  != undefined)
        this.$router.push({path:"/home/"+curnode.idx})
    },
    //获取选中研究井位下拉框的数据
    handleWellCheckChange(data) {
      //单击单井信息
      if (!data.children) {
        this.$root.wellData = data.label;
        //存储选中单井号到vuex中
        this.$store.state.wellData = [];
        this.$store.state.wellData.push(data.label);
        // console.log(data);
        console.log(this.$store.state.wellData);
      } else {//单击井分类信息
        console.log(data);
        this.$store.state.wellData = [];
        // 屏蔽选择井分类的钻取改为区块
        let wells = [];
        let wellData = [];
        let label=null;
        let checkednodes = [];
        for (let key in this.checkedBlock)
          checkednodes.push(this.checkedBlock[key]);
        if (checkednodes.length > 0) {
          label=checkednodes[0].label;
          for (let nodeIdx in checkednodes) {
            let data = checkednodes[nodeIdx];
            //判断是否是最小的节点
            if (data.ISLEAF === 1) {
              //获取最小区块名称
              wellData.push(data.label);
            }
          }
        }
        wells.push(label);
        wells.push(wellData);
        wells.push("qk");
        wells.push(this.blkTypeGroupId);
        // let well = [];
        // let wellData = [];
        // well.push(data.label);
        // let len = data.children.length;
        // for (let i = 0; i < len; i++) {
        //   if(!data.children[i].children) {
        //     wellData.push(data.children[i].label);
        //   }
        //   else{
        //     let len2 = data.children[i].children.length;
        //     for (let j = 0; j < len2; j++) {
        //       wellData.push(data.children[i].children[j].label);
        //     }
        //   }
        // }
        // well.push(wellData);
        // well.push("jz");
        this.$store.state.wellData = wells;
        // console.log(well);
      }
    },

    //添加个人井组
    onClickUserNodeAdd(data){
      //清空数据
      this.userBlocks.id="";
      this.userBlocks.name="";
      this.userBlocks.blockCheckedKeys=[];
      this.userBlocks.wellCheckedKeys=[];
      this.userBlocks.wellBlockIds=[];
      this.userBlocks.wells=[];
      this.userBlocks.pid=data.value;//获取父id
      this.userBlocks.wellPkey="";
      this.blockExpandedKeys=["237f0197-b323-49c6-8a74-4c955d1c5c5d"];//区块tree默认展开”塔里木油田“
      this.blockCheckedKeyList=[];
      this.checkedBlockUser={};
      this.getUserBlockData();//获取区块数据
      this.getUserWellData();//获取井数据
      this.selectionUserBlock=true;
    },
    //获取用户权限区块
    getUserBlockData(){
      let that = this;
      that.blkprogressvisible = true;
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (jwtSession == null) jwtSession = "";
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/bankGeoUnit",
        headers: {
          "Authorization": "Bearer " + jwtSession
        },
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          this.userBlockData = res.data;
          console.log("区块：",res.data);
        }
        that.blkprogressvisible = false;
      }).catch((err) => {
        console.log(err)
        that.blkprogressvisible = false;
      })
    },
    //获取用户勾选区块对应井数据
    getUserWellData(){
      // let checkedBlock={"0AED13F2D11142FFB3A75CBF6B0B1C47":{}};//默认获取东河1区块井数据
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/bankWellData",
        method: 'POST',
        headers: {"Content-Type": "application/json"},
        data: this.checkedBlockUser
      }).then((res) => {
        console.log(res);
        this.userWellData=res.data;
      }).catch((err) => {
        alert('Error');
        console.log(err)
      })
    },
    //选井弹出框确认（添加个人井组）
    addUserBlock(){
      console.log("新增井组：",this.userBlocks);
      //数据验证判断
      if (this.userBlocks.name==""){
        ElMessage.info("井组名称不能为空")
        return
      }
      if (this.userBlocks.wells.length==0){
        ElMessage.info("请勾选井")
        return
      }
      if (this.data[0].children!=undefined || this.data[0].children!=null){
        let isVerify=true;
        this.data[0].children.forEach(item=>{
          if (item.label==this.userBlocks.name && item.value!=this.userBlocks.id){
            ElMessage.info("井组名称不能重复");
            isVerify=false;
            return
          }
        })
        if (!isVerify)
          return
      }
      if (this.userBlocks.wellPkey==""){
        ElMessage.info("请选择主井")
        return;
      }
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/addUserBlock", {
        "data": this.userBlocks,
        "userId": this.lyqtUserInfoUserId,
      }).then(res => {
        // console.log(res);
        this.fetchData();//刷新区块数据
        ElMessage.success(res.data.message);
      }).catch(err => {
        console.log(err);
      })
      this.selectionUserBlock=false;
    },
    //修改个人井组
    onClickUserNodeRename(data){
      console.log(data)
      this.userBlocks.id=data.value;//获取井组id
      this.userBlocks.pid=data.pid;//获取井组父id
      this.userBlocks.name=data.label;//获取井组名称
      this.userBlocks.wells=data.wells;//获取井组名称
      this.userBlocks.blockCheckedKeys=data.blockCheckedKeys;//获取勾选区块id
      this.userBlocks.wellCheckedKeys=data.wellCheckedKeys;//获取勾选井id
      this.userBlocks.wellBlockIds=data.wellBlockIds;//获取勾选井对应区块id
      this.userBlocks.wellPkey = data.wellPkey!=undefined ?  data.wellPkey : "";//获取主井
      this.checkedBlockUser = {};//根据勾选区块获取区块id
      if (this.userBlocks.blockCheckedKeys != null) {
        this.userBlocks.blockCheckedKeys.forEach(item => {
          this.checkedBlockUser[item] = "";
        })
      }
      this.blockExpandedKeys = data.blockCheckedKeys;//获取区块tree默认展开id
      this.blockCheckedKeyList = data.blockCheckedKeys;//获取区块tree默认勾选id
      this.getUserBlockData();//获取区块数据
      this.getUserWellData();//获取井数据
      this.selectionUserBlock=true;
    },
    //删除个人井组
    onClickUserNodeDel(data){
      let url=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/actionUserWell";//axios地址
      ElMessageBox.confirm(
          '确定删除？',
          '警告',
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: 'warning',
          }
      ).then(()=>{
        axios.post(url,{
          id:data.value,
        }).then(res=>{
          // console.log(res);
          ElMessage.success(res.data.message);
          this.fetchData();//刷新区块数据
        }).catch(err=>{
          console.log(err);
        })
      }).catch(()=>{})
    },
    //获取勾选油田数据
    handleBlockCheckUser(currentNode, checkedObjs) {
      //拼接查询井数据的区块信息
      this.checkedBlockUser = {};
      let checkednodes = checkedObjs.checkedNodes;
      if (checkednodes.length > 0) {
        for (let nodeIdx in checkedObjs.checkedNodes) {
          let data = checkednodes[nodeIdx];
          //判断是否是最小的节点
          if (data.ISLEAF === 1) {
            this.checkedBlockUser[data.BLOCK_ID] = data;
          }
        }
      }

      this.userBlocks.blockCheckedKeys = checkedObjs.checkedKeys;//记录勾选区块id
      //获取区块tree默认展开,勾选id
      if (this.userBlocks.blockCheckedKeys.length==0){
        this.blockExpandedKeys=["237f0197-b323-49c6-8a74-4c955d1c5c5d"];
        this.blockCheckedKeyList=[];
      }
      else {
        this.blockExpandedKeys = checkedObjs.checkedKeys;
        this.blockCheckedKeyList = checkedObjs.checkedKeys;
      }
      //判断新勾选的区块是否包含已勾选井，保留对应区块已勾选的井
      let wellGrupOneData = [];//井名
      let wellBlockIds = [];//井对应的区块id
      let checkedKeys = [];//勾选井id
      let blockCheckedKeysStr=JSON.stringify(this.userBlocks.blockCheckedKeys);
      this.userBlocks.wellBlockIds.forEach((item,idx)=>{
        if (blockCheckedKeysStr.indexOf(item)!=-1){
          wellGrupOneData.push(this.userBlocks.wells[idx]); //获取井名称
          wellBlockIds.push(this.userBlocks.wellBlockIds[idx]);//获取井对应区块id
          checkedKeys.push(this.userBlocks.wellCheckedKeys[idx]);//获取井id
        }
      })
      let isNotPkey=true;//判断当前勾选井中是否存在主井
      wellGrupOneData.forEach(item=>{
        if (item==this.userBlocks.wellPkey){
          isNotPkey=false;
          return
        }
      });
      if (isNotPkey)
        this.userBlocks.wellPkey="";
      this.userBlocks.wells = wellGrupOneData;
      this.userBlocks.wellBlockIds = wellBlockIds;
      this.userBlocks.wellCheckedKeys = checkedKeys;//记录勾选井id
      this.getUserWellData();//刷新井数据
    },
    //获取勾选个人井组数据
    handleWellCheckUser(currentNode, checkedObjs) {
      console.log(currentNode)
      console.log(checkedObjs)
      let wellGrupOneData = [];//井名
      let wellBlockIds = [];//井对应的区块id
      let checkedKeys = [];//勾选井id
      let checkednodes = checkedObjs.checkedNodes;

      for (let nodeIdx in checkedObjs.checkedNodes) {
        let data = checkednodes[nodeIdx];
        //判断是否是最小的节点
        if (!data.children) {
          wellGrupOneData.push(data.label); //获取井名称
          wellBlockIds.push(data.LEVBLKID);//获取井对应区块id
          checkedKeys.push(data.id);//获取井id
        }
      }
      let isNotPkey=true;//判断当前勾选井中是否存在主井
      wellGrupOneData.forEach(item=>{
        if (item==this.userBlocks.wellPkey){
          isNotPkey=false;
          return
        }
      });
      if (isNotPkey)
        this.userBlocks.wellPkey="";
      this.userBlocks.wells = wellGrupOneData;
      this.userBlocks.wellBlockIds = wellBlockIds;
      this.userBlocks.wellCheckedKeys = checkedKeys;//记录勾选井id
    },
    //tree组件 搜索筛选 过滤节点——个人井组选井弹出框
    userBlocksFilterNode(value, data) {
      if (!value) return true;
      return data.label
          .indexOf(value) !== -1;
    },
  },
  data() {
    return {
      isShowWellOld:false,//显示井面板上次的状态
      isshowWells:this.isShowWell,//显示井面板上次的状态
      wellIsFetched:false,
      wellDataUrl:process.env.VUE_APP_SERVER + "/dataprovider/systemdata/wellData",//获取井数据地址
      blkDataUrl:process.env.VUE_APP_SERVER + "/dataprovider/systemdata/blockData",//获取区块信息地址
      blkTypeGroupId: '02',//区块分类： 01：一期，02：银行，03：计划区块,04:个人井组
      blkTypeGroupName:"油田区块(一期)",
      wellfilterText: '',
      filterText: '',
      activeNames: ["1", "2"],
      data: [],
      defcheckedBlk: [],//默认勾选节点
      defexpandBlk: [0],//默认展开节点
      welldata: [],//井资料
      qkWellMap: {},//银行区块与井的对应关系
      fullBankWellData:[],//所有银行井数据
      navigationData: [],//导航数据
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      checkedBlock: {},
      userip_in:"",
      wellprogressvisible: false,//研究井位 数据加载标识
      blkprogressvisible: false,//研究对象 数据加载标识

      selectionUserBlock:false,//个人井组选井弹出框标识
      userBlockData:[],//接收用户权限区块井数据
      userWellData:[],//接收用户权限区块井数据
      checkedBlockUser:{},//接受个人井组选井界面勾选区块数据
      userBlocks:{
        id:"",//井组id（更新有值，新增无值）
        name:"",//井组名称
        wells:[],//勾选井列表
        wellBlockIds:[],//勾选井对应的区块id列表
        wellCheckedKeys:[],//勾选井数据 id集合，用于打开时的数据勾选展示
        wellFilterText:"",//井名称检索文本
        blockCheckedKeys:[],//勾选区块数据 id集合，用于打开时的数据勾选展示
        blockFilterText:"",//区块名称检索文本
        pid:"",//父节点id
        wellPkey:"",//主井名称
      },//添加个人井组相关数据
      blockExpandedKeys:[],//区块tree默认展开集合
      blockCheckedKeyList:[],//区块tree默认勾选集合
      lyqtUserInfoUserId:"",//用户id
    };
  },
  props: {
    rootNavigateId: {
      default: {}
    },
    isShowFunc: {
      default: {}
    },
    isShowWell: {
      default: false
    }
  }
}
</script>
<style scoped>
/deep/.el-menu {
  border-right: 0;
}
.el-menu-item {
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  color: #303133;
  cursor: pointer;
  position: relative;
  -webkit-transition: border-color .3s,background-color .3s,color .3s;
  transition: border-color .3s,background-color .3s,color .3s;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  white-space: nowrap;
}
/deep/.el-submenu__title {
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  color: #303133;
  cursor: pointer;
  position: relative;
  -webkit-transition: border-color .3s,background-color .3s,color .3s;
  transition: border-color .3s,background-color .3s,color .3s;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  white-space: nowrap;
}
.colspaseTitle{
  font-size: 16px;
  display: flex;
  align-items: center;
}
/deep/.el-scrollbar__view{
  display: inline-block;
}

/deep/.el-tree-node.is-current > .el-tree-node__content {
  background-color: #4499e91a !important;
  color: #333333 ;
}
/deep/.el-card__header{
  padding: 8px 20px;
}
/*/deep/.el-submenu__title i {*/
/*  color: #6C6E6F;*/
/*}*/
/*.tabContainer {*/
/*  width: 1200px;*/
/*  height: auto;*/
/*  margin: 0 auto;*/
/*  background: #D4E3FB;*/
/*  position: relative;*/
/*}*/
/*.tabContainer .el-tabs--border-card{*/
/*  border: none;*/
/*  -webkit-box-shadow: none;*/
/*  box-shadow: none;*/
/*}*/
/*.tabContainer > .el-tabs--border-card > .el-tabs__header {*/
/*  !**!*/
/*  background-color: #ccc;*/
/*  border: none;*/
/*  border-top: 1px solid #e4e7ed;*/
/*  border-radius: 3px;*/
/*  margin: 0;*/
/*}*/
/*.tabContainer .el-tabs--border-card>.el-tabs__header .el-tabs__item{*/
/*  color: #FFFFFF;*/
/*  text-align: center;*/
/*  border: none;*/
/*  min-width: 80px;*/
/*}*/
/*.tabContainer .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {*/
/*  color: #1B2945;*/
/*  background-color: #FFF;*/
/*  !*border-right-color: #DCDFE6;*!*/
/*  !*border-left-color: #DCDFE6;*!*/
/*  border: none;*/
/*  box-shadow: none;*/
/*}*/
/*.el-tabs--border-card > .el-tabs__content {*/
/*  margin: 0;*/
/*  padding: 15px;*/
/*  height: 0;*/
/*  background: #efefef;*/
/*}*/
/*.tabContainer .el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover {*/
/*  color: #409EFF;*/
/*  !*color: #FFFFFF;*!*/
/*}*/
/*!*input*!*/
/*.tabContainer .tabInput {*/
/*  background: none;*/
/*  width: 160px;*/
/*  height: 28px;*/
/*  position: absolute;*/
/*  right: 0;*/
/*  top: 5px;*/
/*  margin-right: 10px;*/
/*}*/
/*.tabContainer .el-input__inner {*/
/*  -webkit-appearance: none;*/
/*  background: none;*/
/*  border-radius: 4px;*/
/*  border: 1px solid #DCDFE6;*/
/*  -webkit-box-sizing: border-box;*/
/*  box-sizing: border-box;*/
/*  color: #606266;*/
/*  display: inline-block;*/
/*  font-size: 15px;*/
/*  height: 28px;*/
/*  line-height: 28px;*/
/*  outline: 0;*/
/*  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);*/
/*  width: 100%;*/
/*}*/
/*.tabContainer .el-input__icon {*/
/*  height: 100%;*/
/*  width: 25px;*/
/*  text-align: center;*/
/*  -webkit-transition: all .3s;*/
/*  transition: all .3s;*/
/*  line-height: 28px;*/
/*}*/
/*.el-tabs__item.is-active {*/
/*  color: #409EFF;*/
/*  background-color: white;*/
/*}*/
/*.el-tabs__item {*/
/*  background-color: #EEEEEE;*/
/*  height: 40px;*/
/*  right: 0;*/
/*  top: 5px;*/
/*  margin-right: 10px;*/

/*  !*padding: 0 20px;*!*/
/*  -webkit-box-sizing: border-box;*/
/*  box-sizing: border-box;*/
/*  line-height: 40px;*/
/*  display: inline-block;*/
/*  list-style: none;*/
/*  font-size: 14px;*/
/*  font-weight: 500;*/
/*  !*color: #303133;*!*/
/*  !*color: gray;*!*/
/*  position: relative;*/

/*  !*-webkit-appearance: none;*!*/
/*  !*background: none;*!*/
/*  border-radius: 10px;*/
/*  border: 1px solid #DCDFE6;*/
/*  -webkit-box-sizing: border-box;*/
/*  box-sizing: border-box;*/
/*  color: #606266;*/
/*  display: inline-block;*/
/*  !*font-size: 15px;*!*/
/*  !*height: 28px;*!*/
/*  !*line-height: 28px;*!*/
/*  outline: 0;*/
/*  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);*/
/*  !*width: 100%;*!*/
/*}*/
/*.el-tabs__item:hover {*/
/*  color: #409EFF;*/
/*  cursor: pointer;*/
/*}*/
/*.el-tabs__active-bar {*/
/*  position: absolute;*/
/*  bottom: 0;*/
/*  left: 0;*/
/*  height: 2px;*/
/*  !*background-color: #409EFF;*!*/
/*  background: none;*/
/*  z-index: 1;*/
/*  transition: transform .3s cubic-bezier(.645,.045,.355,1),-webkit-transform .3s cubic-bezier(.645,.045,.355,1);*/
/*  list-style: none;*/
/*}*/
/*.el-tabs__nav {*/
/*  white-space: nowrap;*/
/*  position: relative;*/
/*  border-bottom: 2px solid gray;*/
/*  transition: transform .3s,-webkit-transform .3s;*/
/*  float: left;*/
/*  z-index: 1;*/
/*}*/
/*.el-button--primary{*/
/*  background-color:#545c64;*/
/*  border-color: #545c64;*/
/*}*/
/*.el-button--primary:focus, .el-button--primary:hover{*/
/*  background-color:#88969d;*/
/*  border-color: #88969d;*/
/*}*/
</style>